var map = {
	"./404.b2e343f8.png": "a6ee",
	"./404.png": "16f4",
	"./FacetedSearch.2c86ff97.png": "a78b",
	"./FacetedSearch.png": "ec12",
	"./SearchBar.28ead402.png": "11a0",
	"./SearchBar.png": "72ed",
	"./SearchResultCard.5d1e62d9.png": "557a",
	"./SearchResultCard.png": "9dd9",
	"./UnderDevelop.ea0865b6.png": "07c1",
	"./UnderDevelop.png": "df56",
	"./UnderDevelop2.0340b8c7.png": "bb48",
	"./UnderDevelop2.png": "29e1",
	"./addNodeIcon.a1a2d01b.a1a2d01b.png": "2dd8",
	"./addNodeIcon.a1a2d01b.png": "2bf4",
	"./admin-page/graphics/left-bubble.svg": "73ec",
	"./admin-page/icons/ai-brain.svg": "9a2b",
	"./admin-page/icons/circle-dual-arrow.svg": "55f2",
	"./admin-page/icons/circle-right-arrow.svg": "4164",
	"./admin-page/icons/csv.svg": "67a2",
	"./admin-page/icons/filesystem.svg": "2057",
	"./admin-page/icons/html.svg": "adfc",
	"./admin-page/icons/robo-talk.svg": "82ce",
	"./admin-page/icons/sharepoint.svg": "63ba",
	"./admin-page/icons/spider.svg": "de7b",
	"./alt-home-banner.a8a0e4e4.png": "13f5",
	"./alt-home-banner.png": "a0a7",
	"./alt-home-page/alt-home-banner.png": "a0a6",
	"./backIcon.dd0baa69.dd0baa69.png": "63ae",
	"./backIcon.dd0baa69.png": "0ce6",
	"./connectIcon.d5267b8d.d5267b8d.png": "ca9f",
	"./connectIcon.d5267b8d.png": "a89d",
	"./cross.260c9c65.260c9c65.png": "1800",
	"./cross.260c9c65.png": "8268",
	"./deleteIcon.02d321ed.02d321ed.png": "b8d9",
	"./deleteIcon.02d321ed.png": "4257",
	"./downArrow.bbfbf2e8.bbfbf2e8.png": "2f82",
	"./downArrow.bbfbf2e8.png": "8ba2",
	"./editIcon.d5422321.d5422321.png": "61d2",
	"./editIcon.d5422321.png": "147d",
	"./empty.5f8c864e.png": "8bc3",
	"./empty.png": "1427",
	"./fontawesome.config": "c546",
	"./fontawesome.config.js": "c546",
	"./guided_icons/back-thoracic.svg": "b2d3",
	"./guided_icons/head.svg": "32a2",
	"./guided_icons/lower-limb.svg": "f987",
	"./guided_icons/miscellaneous.svg": "0d68",
	"./guided_icons/neck-cervical.svg": "cb4d",
	"./guided_icons/psychiatric.svg": "c20d",
	"./guided_icons/torso-internal.svg": "8f27",
	"./guided_icons/upper-limb.svg": "87d8",
	"./icrs/css/animate.min.css": "3cb5",
	"./icrs/css/aos.min.css": "440c",
	"./icrs/css/cluxp.css": "15b2",
	"./icrs/css/jds.css": "3735",
	"./icrs/files/icrs_sample_upload_excel_template.xlsx": "8479",
	"./icrs/files/icrs_upload_excel_guide.docx": "4a3d",
	"./icrs/files/icrs_upload_excel_guide.pdf": "582c",
	"./icrs/files/user_guide.pdf": "1fb8",
	"./icrs/files/user_guide_v1.0.pdf": "74ed",
	"./icrs/fonts/roboto/Roboto-Bold.woff": "34fc",
	"./icrs/fonts/roboto/Roboto-Bold.woff2": "07ef",
	"./icrs/fonts/roboto/Roboto-Light.woff": "d637",
	"./icrs/fonts/roboto/Roboto-Light.woff2": "2fed",
	"./icrs/fonts/roboto/Roboto-Medium.woff": "05a0",
	"./icrs/fonts/roboto/Roboto-Medium.woff2": "35b1",
	"./icrs/fonts/roboto/Roboto-Regular.woff": "83ec",
	"./icrs/fonts/roboto/Roboto-Regular.woff2": "d04c",
	"./icrs/images/archive/help_indicators.gif": "b89a",
	"./icrs/images/archive/help_scatter.gif": "032d",
	"./icrs/images/archive/icrs-logo.png": "6147",
	"./icrs/images/archive/maco-logo.png": "4077",
	"./icrs/images/award-summary.png": "2c3f",
	"./icrs/images/cl-logo.png": "4b10",
	"./icrs/images/guided-search.png": "01b7",
	"./icrs/images/help_indicators.gif": "3966",
	"./icrs/images/help_scatter.gif": "1d0f",
	"./icrs/images/hero-img.png": "5aab",
	"./icrs/images/icrs-logo.png": "8b27",
	"./icrs/images/icrs-wording.png": "ffc2",
	"./icrs/images/img1.jpg": "0217",
	"./icrs/images/img2.jpg": "ceb9",
	"./icrs/images/img3.jpg": "5195",
	"./icrs/images/img4.jpg": "4f08",
	"./icrs/images/lawnet.svg": "d039",
	"./icrs/images/logo-white.svg": "1806",
	"./icrs/images/myinfo.svg": "4021",
	"./icrs/images/raw_lawnet.svg": "073c",
	"./icrs/images/sal-logo.png": "2c4f",
	"./icrs/images/scatter-plot.png": "7ef5",
	"./icrs/images/sg-courts-logo.svg": "9536",
	"./icrs/images/sg-gov.svg": "f992",
	"./icrs/images/supreme-court-background-login.jpg": "d1a3",
	"./icrs/images/supreme-court-background.jpg": "c37e",
	"./icrs/js/aos.min": "0cbc",
	"./icrs/js/aos.min.js": "0cbc",
	"./leftArrow.8965662a.8965662a.png": "492c",
	"./leftArrow.8965662a.png": "7fc1",
	"./login-illustration.3bc9bb27.jpeg": "00fd",
	"./login-illustration.jpeg": "9f0b",
	"./logo.png": "cf05",
	"./logo_vue.82b9c7a5.png": "954e",
	"./logo_vue.png": "1d07",
	"./minus.5a379c46.5a379c46.png": "8b6a",
	"./minus.5a379c46.png": "0290",
	"./notification.png": "203a",
	"./ontology-pro-tips-filters.ddbe196f.png": "d5be",
	"./ontology-pro-tips-filters.png": "6f01",
	"./ontology-pro-tips-knowledge-graph.74127e0a.png": "6770",
	"./ontology-pro-tips-knowledge-graph.png": "a91f",
	"./ontology-search-illustration.1da0f75b.png": "332d",
	"./ontology-search-illustration.png": "ec3d",
	"./plus.4c4bf0a1.4c4bf0a1.png": "94e3",
	"./plus.4c4bf0a1.png": "32bf",
	"./pro-light-svg-icons": "5e1e",
	"./pro-light-svg-icons/": "5e1e",
	"./pro-light-svg-icons/index": "5e1e",
	"./pro-light-svg-icons/index.js": "5e1e",
	"./pro-regular-svg-icons": "dd82",
	"./pro-regular-svg-icons/": "dd82",
	"./pro-regular-svg-icons/index": "dd82",
	"./pro-regular-svg-icons/index.js": "dd82",
	"./rightArrow.4f88ef17.4f88ef17.png": "b597",
	"./rightArrow.4f88ef17.png": "8ef4",
	"./search-in-progress.7b6222a9.png": "279e",
	"./search-in-progress.png": "2853",
	"./taiger-logo-black.9c81e856.png": "8c5a",
	"./taiger-logo-black.png": "6889",
	"./taiger-logo-white-horizontal.svg": "e626",
	"./tds-icons/app_logo.svg": "128c",
	"./tds-icons/arrow_back.svg": "d52b",
	"./tds-icons/arrow_next.svg": "db7f",
	"./tds-icons/check.svg": "e3ae",
	"./tds-icons/grid.svg": "54a1",
	"./tds-icons/loading_blue.svg": "d6e0",
	"./tds-icons/user.svg": "eaac",
	"./ui-catalog-page/FacetedSearch.png": "82fc",
	"./ui-catalog-page/SearchBar.png": "f8c9",
	"./ui-catalog-page/SearchResultCard.png": "ed31",
	"./ui-catalog-page/UnderDevelop.png": "0509",
	"./ui-catalog-page/UnderDevelop2.png": "99fa",
	"./unauthorized.svg": "e86d",
	"./upArrow.f0aa0566.f0aa0566.png": "2562",
	"./upArrow.f0aa0566.png": "3a12",
	"./upload-icons/img.svg": "b32f",
	"./upload-icons/xlsx.svg": "118c",
	"./zoomExtends.5f78e86f.5f78e86f.png": "0b29",
	"./zoomExtends.5f78e86f.png": "9992"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";